import React, { useEffect, useRef, useState } from 'react';

const Banner = () => {
  const carouselRef = useRef(null);
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    fetch("https://adinathbuilder.com/admin/api/banner")
      .then((res) => res.json())
      .then((resData) => {
        if (resData.status && Array.isArray(resData.data)) {
          const formattedData = resData.data.map((item) => {
            const fullPath = `https://adinathbuilder.com/admin/public/${item.video_path}`;
            const extension = item.video_path.split('.').pop().toLowerCase();
            const isVideo = ['mp4', 'webm', 'ogg'].includes(extension);
            return { src: fullPath, type: isVideo ? 'video' : 'image' };
          });
          setBanners(formattedData);
        } else {
          console.error("Unexpected response format", resData);
        }
      })
      .catch((err) => console.error("Failed to load banners", err));
  }, []);

  useEffect(() => {
    import('bootstrap/dist/js/bootstrap.bundle.min.js').then((bootstrap) => {
      if (carouselRef.current) {
        new bootstrap.Carousel(carouselRef.current, {
          interval: 4000,
          ride: 'carousel',
          pause: false,
          touch: true,
          wrap: true,
        });
      }
    });
  }, [banners]);

  return (
    <div style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
      <style>{`
        .carousel-item video,
        .carousel-item img {
          height: 630px;
          width: 100%;
          object-fit: cover;
        }

        @media (max-width: 768px) {
          .carousel-item video,
          .carousel-item img {
            height: 300px;
          }
        }
      `}</style>

      <div
        id="carouselExampleCaptions"
        className="carousel slide"
        ref={carouselRef}
      >
        <div className="carousel-indicators">
          {banners.map((_, index) => (
            <button
              key={index}
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to={index}
              className={index === 0 ? 'active' : ''}
              aria-current={index === 0 ? 'true' : undefined}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
        </div>

        <div className="carousel-inner">
          {banners.map((item, index) => (
            <div
              className={`carousel-item ${index === 0 ? 'active' : ''}`}
              key={index}
            >
              {item.type === 'video' ? (
                <video
                  className="d-block w-100"
                  autoPlay
                  muted
                  loop
                  playsInline
                >
                  <source src={item.src} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img
                  className="d-block w-100"
                  src={item.src}
                  alt={`Slide ${index + 1}`}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Banner;
